import { Box } from '@betterment/samba-react';

/**
 * Renders visually hidden text for screen reader accessibility.
 *
 * Use this component to provide descriptive text for charts that is accessible to
 * screen readers but hidden from visual display. The id should match the chart's
 * `aria-describedby` attribute.
 *
 * @example
 * ```tsx
 * <HiddenChartDescription id="balance-chart-desc">
 *   This chart shows your account balance and invested amount over the past year.
 *   Balance is shown as a blue area, invested amount as a dashed line.
 * </HiddenChartDescription>
 *
 * <BalanceChart
 *   data={data}
 *   width={600}
 *   height={400}
 *   aria-label="Account balance over time"
 *   aria-describedby="balance-chart-desc"
 * />
 * ```
 */
export const HiddenChartDescription = ({ id, children }: { id: string; children: React.ReactNode }) => {
  return (
    <Box id={id} css={{ srOnly: true }}>
      {children}
    </Box>
  );
};
